<template>
  <div>
    <div class="flex py2 border-bottom items-center">
      <div
        class="inline-block mx2 flex items-center justify-center grey-bg avatar center circle"
      >
        <i class="icon relative line-height-1 h2 white i-user"></i>
      </div>
      <div class="flex-auto">
        <span class="h4 caps mr1 bold">{{ currentParticipant.firstname }}</span>
        <span class="h4 caps bold">{{ currentParticipant.lastname }}</span>
        <br>
        <i class="icon icon-calendar mr1"></i>
        <span class="h5">{{ currentParticipant.birth_date }}</span>
      </div>
      <!-- use this label to show documents user status in CRM -->
      <div
        :class="['p1 white h6 bold xs-hide sm-hide valid-user-tag', {'green-bg': validInfo}, {'red-bg': !validInfo}]"
      >
        <i :class="['icon mr1', {'icon-check-icon': validInfo}, {'icon-attention': !validInfo}]"></i>
        <span>{{ validInfo ? 'documents valides' : 'documents à valider' }}</span>
      </div>
    </div>

    <!-- use this label to show documents user status in CRM -->
    <div :class="['p1 h6 md-hide lg-hide bold col-12 no-box white', {'green-bg': validInfo}, {'red-bg': !validInfo}]">
      <i :class="['icon mr1', {'icon-check-icon': validInfo}, {'icon-attention': !validInfo}]"></i>
      <span>{{ validInfo ? 'documents valides' : 'documents à valider' }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: { currentParticipant: Object },
  computed: {
    validInfo () {
      return this.currentParticipant.tariff.validInfo;
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
